export default "__VITE_ASSET__Bfju6jOi__"